import { create } from 'zustand';
import { PlayMode, EditorState } from '../../core/types/editor.types';

interface EditorStore extends EditorState {
  // Actions
  setPlayMode: (mode: PlayMode) => void;
  play: () => void;
  pause: () => void;
  stop: () => void;
  step: () => void;
  setFps: (fps: number) => void;
  setObjectCount: (count: number) => void;
  setProjectName: (name: string) => void;
  setHasUnsavedChanges: (hasChanges: boolean) => void;
}

export const useEditorStore = create<EditorStore>()(
  (set, get) => ({
    // Initial state
    playMode: 'edit',
    fps: 0,
    objectCount: 0,
    projectName: 'Untitled Project',
    hasUnsavedChanges: false,

    // Actions
    setPlayMode: (mode) => set({ playMode: mode }),

    play: () => {
      const { playMode } = get();
      if (playMode === 'edit' || playMode === 'paused') {
        set({ playMode: 'playing' });
      }
    },

    pause: () => {
      const { playMode } = get();
      if (playMode === 'playing') {
        set({ playMode: 'paused' });
      }
    },

    stop: () => {
      set({ playMode: 'edit' });
    },

    step: () => {
      const { playMode } = get();
      if (playMode === 'paused') {
        console.log('Step frame');
      }
    },

    setFps: (fps) => set({ fps }),
    setObjectCount: (count) => set({ objectCount: count }),
    setProjectName: (name) => set({ projectName: name }),
    setHasUnsavedChanges: (hasChanges) => set({ hasUnsavedChanges: hasChanges }),
  }),
);
